import { configureStore } from "@reduxjs/toolkit";
import appSlice from "../../LayoutContainers/AppLayout/redux/AppSlice";

export default configureStore({
  reducer: {
    app: appSlice,
  },
});
